import styled from "styled-components";
import { Title as SundayTitle, Body as SundayBody } from "sunday-component";
import CommonButton from "src/components/Common/Button";
import { color } from "src/styles/globals";
import { Col, Row } from "antd";
import LinkTitle from "src/components/Common/LinkTitle";

export const Title = styled(SundayTitle)`
  color: ${color.charcoal10};
`;

export const EditTitle = styled(LinkTitle)`
  cursor: pointer;
`;

export const ButtonTitle = styled(SundayTitle)`
  color: inherit;
`;

export const Body = styled(SundayBody)`
  color: ${color.charcoal09};
`;

export const FieldBody = styled(SundayBody)`
  color: ${color.charcoal10};
`;

export const InfoHeaderContainer = styled.div`
  margin: 0px 0px 16px 0px;
`;

export const InfoTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0px 0px 8px; 0px;
  width: 100%;
`;

export const FieldSection = styled.div`
  display: flex;
`;

export const FieldImageContainer = styled.div`
  height: 24px;
  vertical-align: top;
`;

export const FieldTitleContainer = styled.div`
  display: inline-block;
  vertical-align: top;
  margin: 0px 0px 0px 8px;
`;

export const FieldContentContainer = styled.div`
  display: inline-block;
  vertical-align: top;
`;

export const Button = styled(CommonButton)`
  padding: 13px 28px;
  height: 50px !important;
  margin: 16px 0px 0px 0px;
`;

export const FieldRowContainer = styled(Row)`
  margin: 8px 0px 0px 0px;
`;

export const LeftContainer = styled(Col)`
  margin: 0px 16px 0px 0px;
`;

export const RightContainer = styled(Col)`
  overflow: auto;
  flex: 1;
`;
